var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IncentivesDSMetadatas_1;
import { JsonConverter, JsonSchemaV2, MapConverter } from '@symon-ai/wisepipe-serialize';
import './incentivesDatasourceMeta'; // force import for JsonSchemaV2
import { incentivesDSMetadatasSchemaValidation } from '../validations.generated';
export const incentivesDSMetadatasSchema = {
    $id: 'urn:wisepipe-common-pipe:IncentivesDSMetadatas',
    type: 'object',
    properties: {
        incentivesDSMetadatas: {
            type: 'object',
            additionalProperties: { $ref: 'urn:wisepipe-common-pipe:IncentivesDatasourceMeta' }
        }
    },
    required: ['incentivesDSMetadatas']
};
let IncentivesDSMetadatas = IncentivesDSMetadatas_1 = class IncentivesDSMetadatas {
    constructor(incentivesDSMetadatas) {
        this.incentivesDSMetadatas = new Map();
        this.incentivesDSMetadatas = new Map(incentivesDSMetadatas);
        // Costly to do and not required as it's enforced by Typescript, serialize and deserialize.
        // JSON.validate(this, IncentivesDSMetadatas);
    }
    at(key) {
        return this.incentivesDSMetadatas.get(key);
    }
    has(key) {
        return this.incentivesDSMetadatas.has(key);
    }
    get size() {
        return this.incentivesDSMetadatas.size;
    }
    get names() {
        return Array.from(this.incentivesDSMetadatas.keys());
    }
    static merge(...incentivesDSMetadatas) {
        const merged = new Map();
        for (const datasourceID of incentivesDSMetadatas) {
            for (const item of datasourceID.incentivesDSMetadatas.entries()) {
                merged.set(item[0], item[1]);
            }
        }
        return new IncentivesDSMetadatas_1(merged);
    }
    getPortByDatasourceID(datasourceID) {
        // if there are multiple ports for the same datasourceID, return the lowest numbered port
        let lowestPort;
        for (const [key, value] of this.incentivesDSMetadatas.entries()) {
            if (value.incentivesDatasourceID === datasourceID) {
                if (!key.startsWith('multi_')) {
                    // if it's not a multi port, just return the first one since theres no way to sort them
                    // this shouldnt happen since we only use this function for expand picklist tool right now
                    return key;
                }
                // if it's a multi port, return the lowest numbered port
                if (lowestPort === undefined || Number(key.split('_')[1]) < Number(lowestPort.split('_')[1])) {
                    lowestPort = key;
                }
            }
        }
        return lowestPort;
    }
};
__decorate([
    JsonConverter(new MapConverter())
], IncentivesDSMetadatas.prototype, "incentivesDSMetadatas", void 0);
IncentivesDSMetadatas = IncentivesDSMetadatas_1 = __decorate([
    JsonSchemaV2(incentivesDSMetadatasSchema, incentivesDSMetadatasSchemaValidation)
], IncentivesDSMetadatas);
export { IncentivesDSMetadatas };
(function (IncentivesDSMetadatas) {
    IncentivesDSMetadatas.empty = new IncentivesDSMetadatas(new Map());
})(IncentivesDSMetadatas || (IncentivesDSMetadatas = {}));
//# sourceMappingURL=incentivesDSMetadatas.js.map